import React from 'react'
import './Footer.css'
function Footer({theme}) {
  return (
    <div className={theme==="light"?'footer lightSemiboldColor':'footer darkSemiboldColor'}>© Lishal Bhari. {new Date().getFullYear()} All rights reserved</div>
  )
}

export default Footer